import React from 'react';
import PropTypes from 'prop-types';
import { SmartLink } from '../SmartLink';
import style from './ReportCard.module.scss';

const ReportCard = ({
    title,
    sector,
    image,
    publishingDate,
    cta,
}) => {
    return (
        <div className={style.el}>
            <div className={[style.content, !image ? style.noImage : null].join(' ')}>
                {image && (
                    <div className={style.wrapper}>
                        <div className={style.image}>
                            <div className={style.imageWrap}>
                                <span className={style.imgSpan}>
                                    <img src={image.url} alt={image.alt} />
                                </span>
                            </div>
                        </div>
                    </div>
                )}
                {publishingDate && <div className={[style.wrapper, style.right].join(' ')}>
                    <div className={style.header}>
                        <div className={style.type}>{sector}</div>
                        <div className={style.date}>{publishingDate}</div>
                    </div>
                    <div className={style.title}>
                        <h4 className={style.description}>{title}</h4>
                    </div>
                    {cta?.link?.url && (
                        <div className={style.button}>
                            <SmartLink href={cta.link?.url} hasArrow className='arrow-link'>
                                {cta.text}
                            </SmartLink>
                        </div>
                    )}
                </div>}
            </div>
        </div>
    );
};

ReportCard.propTypes = {
    title: PropTypes.string,
    sector: PropTypes.string,
    image: PropTypes.object,
    publishingDate: PropTypes.string,
    cta: PropTypes.object,
};

export default ReportCard;
